import { commonTranslationKeys } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { patientTranslationKeys } from '../../translations';

import { PatientRemoveFormController } from './PatientRemoveForm.types';

type PatientRemovalDescriptionTextareaProps = Pick<PatientRemoveFormController, 'register'> & {
   readonly required: boolean;
};

export const PatientRemovalDescriptionTextarea = (props: PatientRemovalDescriptionTextareaProps): JSX.Element => {
   const controller = props.register('description', { required: props.required });

   return (
      <Textarea
         rows={3}
         maxRows={5}
         maxLength={255}
         focus={false}
         label={commonTranslationKeys.description}
         controller={controller}
         placeholder={patientTranslationKeys.insertAdditionalData}
         testId={'description'}
      />
   );
};
